var map = {
	"./Asscher@2x.png": 315,
	"./Cushion@2x.png": 316,
	"./Emerald@2x.png": 317,
	"./Faceted Trapezoid@2x.png": 318,
	"./Half Moon@2x.png": 319,
	"./Heart@2x.png": 320,
	"./Marquise@2x.png": 321,
	"./Oval@2x.png": 322,
	"./Pear@2x.png": 323,
	"./Princess@2x.png": 324,
	"./Radiant@2x.png": 325,
	"./Round@2x.png": 326,
	"./Step Cut Trapezoid@2x.png": 327,
	"./Straight Baguette@2x.png": 328,
	"./Tapered Baguette@2x.png": 329,
	"./Triangle@2x.png": 330,
	"./Trilliant@2x.png": 331
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1372;



//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images ^\.\/.*@2x\.png$
// module id = 1372
// module chunks = 0